import React, { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import { AppBar, Box, IconButton, Toolbar, makeStyles } from '@material-ui/core';
import { Menu as MenuIcon } from 'react-feather';
import Logo from '../../components/Logo';
import { Theme } from '../../theme';
import Account from './Account';
import { MyIcon } from 'src/utils/icons/sibarIcon';
interface TopBarProps {
  handleDrawerOpen: () => void;
  openInitial: boolean;
  isMobile: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    width: `calc(100%)`,
    marginLeft: 240,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginLeft: theme.spacing(2)
  },
  hide: {
    display: 'none'
  },
  root: {
    //zIndex: theme.zIndex.drawer + 100,
    backgroundColor: theme.palette.background.default
  }
}));

const TopBar: FC<TopBarProps> = ({ handleDrawerOpen, openInitial }: TopBarProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar
        position="fixed"
        className={clsx(classes.root, {
          [classes.appBarShift]: openInitial
        })}>
        <Toolbar>
          <RouterLink to="/" aria-label="Retornar Menu inicial">
            <Logo />
          </RouterLink>
          <IconButton
            color="default"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, openInitial && classes.hide)}>
           {/*  <MenuIcon /> */}
            <MyIcon />
          </IconButton>

          <Box ml={2} flexGrow={1} />
          <Account />
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default TopBar;
